// extracted by mini-css-extract-plugin
export default {"videoPlayBtn":"index_videoPlayBtn_he35a","playingBtn":"index_playingBtn_2Beq-","pauseBtn":"index_pauseBtn_pLTgS","replayBtn":"index_replayBtn_ym0ER"};